import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-message-box',
  standalone: true,
  templateUrl: './message-box.component.html',
  imports: [
    NgTemplateOutlet,
    NgClass,
    NgIf
  ],
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent {
  @Input() type: 'blocked' | 'login' | 'denied' | string = '';
  @Input() title?: string;
  @Input() icon?: string;

  @ContentChild('header') headerTpl!: TemplateRef<any>;
  @ContentChild('footer') footerTpl!: TemplateRef<any>;
}
